<template>
	<b-modal
		v-model="viewModal"
		id="documentView"
		centered
		hide-footer
		hide-header
		size="lg"
		@hidden="$emit('close-documentView')"
	>
		<div class="d-flex">
			<div class="candash-modal-left width-7"></div>
			<div class="width-93">
				<div class="candash-modal-top p-3">
					<div class="width-97">
						<div class="mb-header-txt">Preview Document</div>
					</div>
					<div class="d-flex justify-content-end pointer">
						<img
							class="rotate-on-hover"
							src="@/assets/newdesign/dashboard/blueCross.svg"
							alt=""
							@click="$emit('close-documentView')"
						/>
					</div>
				</div>
				<div class="d-flex flex-column align-items-center pt-2 pl-4 pr-4">
					<div class="graph-overflow p-2" id="viewDocument">
						<div class="Graph-modal-resume">
							<pdf
								ref="pdf"
								style="box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16)"
								class="h-100 w-100"
								:src="link"
								:page="currentPage"
								@num-pages="numPages = $event"
								@link-clicked="currentPage = $event"
								@page-loaded="currentPage = $event"
							></pdf>
						</div>
					</div>
					<div
						class="asp-pagination align-items-center d-flex h-50px"
						v-if="numPages > 1"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="numPages"
							:per-page="perPage"
							align="center"
							first-number
							last-number
						>
						</b-pagination>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import pdf from "vue-pdf";

export default {
	name: "PreviewDocument",
	components: {
		pdf,
	},
	data() {
		return {
			numPages: 0,
			currentPage: 1,
			perPage: 1,
		};
	},
	props: {
		viewModal: Boolean,
		link: String,
	},
};
</script>
